module.exports = __webpack_public_path__ + "media/out.0d9056b1.wav";